/**
 * Financial Results: kapatılmış ay satırı (katalog s. 14).
 *
 * Seçilen dönemin kapsadığı aylardan muhasebecinin kapattığı her biri için:
 * "🔒 Closed · August 2026 was closed by Yilmaz Muhasebe on 03.09.2026".
 * Kaynak accounting_periods (müşteri kendi profilinin dönemlerini okur, RLS).
 * Kapatan kişinin adı müşteriye açık değil; ofis adı my_accountant'tan.
 */

import { defineFeature } from '../../shell/feature.ts';
import { legacy } from '../../shell/bridge.ts';

const g = globalThis as any;
interface Period { period: string; status: string; closed_by: string | null; closed_at: string | null }

function esc(s: unknown): string { return legacy.escapeHtml(String(s ?? '')); }

/** Satırların kapsadığı aylar, sıralı ve tekil. */
export function monthsOf(rows: Array<{ date?: string }>): string[] {
  return [...new Set(rows.map((r) => String(r?.date ?? '').slice(0, 7)).filter((m) => /^\d{4}-\d{2}$/.test(m)))].sort();
}

async function render(rows: unknown): Promise<void> {
  const box = document.getElementById('fb');
  const sb = legacy.sb;
  const pid = (legacy.user as { sbProfileId?: string } | null)?.sbProfileId;
  if (!box || !sb || !pid || g.navSide?.() !== 'customer') return;
  const months = monthsOf(Array.isArray(rows) ? rows : []);
  box.querySelector('#fr-closed')?.remove();
  if (!months.length) return;
  const r = await sb.from('accounting_periods').select('period,status,closed_by,closed_at')
    .eq('profile_id', pid).eq('status', 'closed').in('period', months);
  const closed: Period[] = (r && !r.error && r.data) || [];
  if (!closed.length) return;
  let firm = 'your accountant';
  try { const a = (await sb.rpc('my_accountant'))?.data; if (a?.linked && a.firm_name) firm = String(a.firm_name); } catch { /* ofis adı yoksa genel ifade */ }
  const me = g._sbUser?.id;
  const lines = closed.sort((a, b) => a.period.localeCompare(b.period)).map((p) => {
    const [y, m] = p.period.split('-').map(Number);
    const label = new Date(y, m - 1, 1).toLocaleDateString('en', { month: 'long', year: 'numeric' });
    const by = p.closed_by && p.closed_by === me ? 'you' : firm;
    const on = p.closed_at ? ` on <span translate="no">${esc(new Date(p.closed_at).toLocaleDateString())}</span>` : '';
    return `<div style="font-size:12px;color:var(--t2);padding:4px 0">🔒 <b style="color:var(--grn)">Closed</b> · ${esc(label)} was closed by ${esc(by)}${on}</div>`;
  }).join('');
  if (!document.getElementById('fb')?.contains(box)) return;
  box.querySelector('#fr-closed')?.remove();
  const div = document.createElement('div');
  div.id = 'fr-closed';
  div.className = 'card';
  div.style.cssText = 'margin:0 0 14px';
  div.innerHTML = lines;
  box.insertBefore(div, box.firstChild);
}

export default defineFeature({
  id: 'results-closed',
  label: 'Sonuçlarda kapatılmış ay',
  view: null,
  legacyGlobals: {
    frClosed: (rows: unknown) => { void render(rows); },
  },
});
